export default "__VITE_ASSET__a49ee747__"